import {gql} from '@apollo/client'

export const CHECK_US_LOCATION = gql`
  query isUsLocation {
    isUsLocation
    currentLocation
  }
`
